import {Trans, useTranslation} from 'react-i18next';

import {
  AppButton,
  AppButtonVariant,
  ButtonContainer,
} from '@/app/shared-components';
import InputTextField from '@/app/shared-components/InputTextField/InputTextField';
import {isProduction} from '@/utils/environment';
import {SeparateChildren} from '@/utils/SeparateChildren';

import {AuthenticationWrapper} from '../../components/AuthenticationWrapper';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

import './styles';

const ResetPasswordContent = () => {
  const {t} = useTranslation();
  const {
    email,
    showConfirmation,
    recoveryToken,
    setEmail,
    handlePressSendRecoveryEmail,
    goToRecoveryLink,
    handleGetRecoveryToken,
    navigate,
    setEmailError,
    disabledButtonSendRecoveryEmail,
  } = useViewModelProvider();

  return (
    <AuthenticationWrapper
      title={t('reset_password_page.title')}
      onBack={() => {
        navigate('/authentication/sign-in');
      }}>
      <SeparateChildren Separator={() => <div style={{height: '20px'}} />}>
        <section className="forgot-password-card">
          {showConfirmation ? (
            <SeparateChildren
              Separator={() => <div style={{height: '20px'}} />}>
              <p>
                <Trans i18nKey="reset_password_page.check_email" />
              </p>
              <ButtonContainer sticky>
                <AppButton
                  id="reset-password-done-button"
                  label={t('reset_password_page.done_button')}
                  variant={AppButtonVariant.onPrimary}
                  onClick={() => navigate('/authentication/sign-in')}
                />
              </ButtonContainer>

              {!isProduction && (
                <section className="dev-buttons">
                  <AppButton
                    id="reset-password-get-token-button"
                    label={t('reset_password_page.get_token_button')}
                    variant={AppButtonVariant.devTool}
                    onClick={handleGetRecoveryToken}
                  />
                  {recoveryToken && (
                    <AppButton
                      id="reset-password-go-to-link-button"
                      label={t('reset_password_page.go_to_link_button')}
                      variant={AppButtonVariant.devTool}
                      onClick={goToRecoveryLink}
                    />
                  )}
                </section>
              )}
            </SeparateChildren>
          ) : (
            <SeparateChildren
              Separator={() => <div style={{height: '20px'}} />}>
              <p>
                <Trans i18nKey="reset_password_page.description_request" />
              </p>
              <InputTextField
                id="reset-password-email-input"
                autoComplete="email"
                type="email"
                label={t('reset_password_page.email_input')}
                placeholder={t('reset_password_page.email_input')}
                value={email}
                setValue={setEmail}
                autofocus
                onErrorChange={setEmailError}
              />
              <ButtonContainer sticky>
                <AppButton
                  id="reset-password-send-recovery-link-button"
                  label={t('reset_password_page.send_me_recovery_link_button')}
                  variant={AppButtonVariant.onPrimary}
                  disabled={disabledButtonSendRecoveryEmail}
                  onClick={handlePressSendRecoveryEmail}
                />
              </ButtonContainer>
            </SeparateChildren>
          )}
        </section>
      </SeparateChildren>
    </AuthenticationWrapper>
  );
};

const ResetPasswordPage = () => (
  <ViewModelProvider>
    <ResetPasswordContent />
  </ViewModelProvider>
);

export default ResetPasswordPage;
